import React from "react";
import './basic-table.css';

export default function BasicTable({className, children}) {
    return <table className={`basic-table ${className}`}>
        {children}
    </table>
}
